"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "recco": {
    "7fdc650f": [{
      "hkey": "7ffa22c0",
      "slug": "angeno-megli",
      "name": "Angeno-Megli",
      "primary": true,
      "skipSearch": false
    }],
    "megli": [{
      "hkey": "7ffa22c0",
      "slug": "angeno-megli",
      "name": "Angeno-Megli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1aba4311": [{
      "hkey": "dd25ebb2",
      "slug": "lungomare-mulinetti-polanesi",
      "name": "Lungomare-Mulinetti-Polanesi",
      "primary": true,
      "skipSearch": false
    }],
    "polanesi": [{
      "hkey": "dd25ebb2",
      "slug": "lungomare-mulinetti-polanesi",
      "name": "Lungomare-Mulinetti-Polanesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e100481e": [{
      "hkey": "00a29e20",
      "slug": "san-rocco-collodari-ponte-di-vexina",
      "name": "San Rocco-Collodari-Ponte di Vexina",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "00a29e20",
      "slug": "san-rocco-collodari-ponte-di-vexina",
      "name": "San Rocco-Collodari-Ponte di Vexina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;